import React from 'react';
import { DetalhesConsultaExterna } from '../../../components/DetalhesConsultaExterna';

export function IniciarAtendimentoConsulta({ record, funcIniAtendimento }) {
  const [state, setState] = React.useState(false);

  React.useEffect(() => {
    const func = async () => {
      const inicioAtendimento = await funcIniAtendimento(record.id, record.status);
      setState(inicioAtendimento);
    };
    func();
  }, []);
  if (!state) return <></>;
  return <DetalhesConsultaExterna detalhes={record} />;
}
